__turbopack_context__.v({
  "footer-row": "footer-row-module-scss-module__C7288a__footer-row",
  "footer-row-container": "footer-row-module-scss-module__C7288a__footer-row-container",
  "gray": "footer-row-module-scss-module__C7288a__gray",
});
